import React, {useContext} from 'react';
import './PrivacyPolicyRegister.css';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';
import PrivacyPolicyDe from './de/PrivacyPolicyDe';

import PrivacyPolicyRegisterDe from './de/PrivacyPolicyRegisterDe';
import PrivacyPolicyRegisterEn from './en/PrivacyPolicyRegisterEn';
import { useIndexUpdate } from '../common/hooks';

export function PrivacyPolicyRegister(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div>
            <div className="bottom_padding side_padding flex_col margin_to_header">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyRegisterDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyRegisterEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>

            <Footer />
        </div>
    );
}
